module.exports = __webpack_public_path__ + "7e0434fb438daa56b843a2a9d5feeaa4.png";